import React from "react";

import { TextArea } from "src/common/components/TextArea";
import { IsLockedContext } from "src/features/forms/context/IsLockedContext";
import { useValue } from "src/features/forms/hooks/useField";
import { CommonProps } from "src/features/forms/types";

export const TextAreaRenderer: React.FunctionComponent<
	CommonProps
> = directProps => {
	const isLocked = React.useContext(IsLockedContext);
	const [value, onChangeValue] = useValue<string | undefined>(undefined);
	return (
		<TextArea
			{...directProps}
			disabled={isLocked}
			value={value}
			onChangeValue={onChangeValue}
		/>
	);
};
